import type { IconProps } from "./types";

export function Money({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.4998 2.59961C17.8186 2.59961 18.1144 2.76912 18.2761 3.04395C18.4376 3.31871 18.4417 3.6589 18.2869 3.9375L16.0779 7.91211L19.8201 12.6543C22.6151 16.1955 20.093 21.4001 15.5818 21.4004H8.30737C3.76333 21.4003 1.25086 16.1295 4.11206 12.5996L7.91675 7.90527L5.71362 3.9375C5.55883 3.65884 5.56282 3.31872 5.72437 3.04395C5.88603 2.7692 6.18099 2.59972 6.49976 2.59961H17.4998ZM5.5105 13.7324C3.6027 16.0857 5.27791 19.5996 8.30737 19.5996H15.5818C18.5892 19.5993 20.2703 16.1303 18.407 13.7695L14.5642 8.90039H9.42847L5.5105 13.7324ZM13.6404 12.7314C13.7886 12.2571 14.2939 11.9925 14.7683 12.1406C15.2427 12.2889 15.5074 12.7941 15.3591 13.2686L15.0974 14.1045C15.5487 14.1531 15.9001 14.5358 15.9001 15C15.9001 15.4971 15.4968 15.9004 14.9998 15.9004H14.5369L14.1091 17.2686C13.9917 17.6442 13.6434 17.9004 13.2498 17.9004C12.8562 17.9003 12.5078 17.6442 12.3904 17.2686L11.9998 16.0186L11.6091 17.2686C11.4917 17.6442 11.1434 17.9004 10.7498 17.9004C10.3562 17.9003 10.0078 17.6442 9.89038 17.2686L9.46265 15.9004H8.99976C8.50283 15.9002 8.09937 15.497 8.09937 15C8.09937 14.5364 8.45053 14.1538 8.90112 14.1045L8.64038 13.2686C8.49217 12.7942 8.75691 12.289 9.2312 12.1406C9.70562 11.9924 10.2109 12.257 10.3591 12.7314L10.7498 13.9814L11.1404 12.7314L11.1951 12.5967C11.3457 12.296 11.6553 12.0997 11.9998 12.0996C12.3934 12.0996 12.7417 12.3557 12.8591 12.7314L13.2498 13.9814L13.6404 12.7314ZM9.53003 7.09961H14.4705L15.9705 4.40039H8.03003L9.53003 7.09961Z"
        fill={currentColor}
      />
    </svg>
  );
}
